import { ArrowRight, Check } from "react-feather";
import { linkCadastro } from "@/lib/constants";
import caneca from "@/assets/images/vitrine-caneca.jpg";
import caderno from "@/assets/images/produto-caderno.jpg";
import garrafa from "@/assets/images/produto-garrafa.jpg";
import ecobag from "@/assets/images/produto-ecobag.jpg";
import carregador from "@/assets/images/produto-carregador.jpg";

// Fotos oficiais de produto com a marca beuni, quadradas e inteiras (nada
// cortado). A da vitrine tem o logo no centro, que aguenta o recorte 5:4.
const PRODUTOS = [
  { src: caderno, alt: "Caderno personalizado da beuni" },
  { src: garrafa, alt: "Garrafa personalizada da beuni" },
  { src: ecobag, alt: "Ecobag personalizada da beuni" },
  { src: carregador, alt: "Carregador sem fio personalizado da beuni" },
];

// Quem abre o rastreio quase sempre é de fora da beuni (quem ganhou o
// presente, o RH de outra empresa), então a página também é vitrine (Murilo,
// 20/10/2026). Dois lugares, cada um com a sua UTM, levando pro cadastro da
// plataforma:
//  - Vitrine: coluna ao lado do rastreio no computador (acompanha a rolagem)
//    e cartão depois do histórico no celular.
//  - FaixaBeuni: faixa de largura inteira antes do rodapé.
// Foto real de kit e texto de verdade, sem cara de anúncio: banner com cara de
// propaganda é o que o olho pula (Nielsen Norman, "banner blindness").

const VANTAGENS = ["Kits e brindes com a sua marca", "Estoque, montagem e envio para todo o Brasil", "Rastreio do começo ao fim, como este"];

export function Vitrine() {
  return (
    <section className="overflow-hidden rounded-3xl bg-white shadow-[0_1px_2px_rgba(63,32,33,0.06),0_8px_24px_rgba(63,32,33,0.06)] ring-1 ring-[#EFE6DD]">
      <img src={caneca} alt="Caneca personalizada da beuni" className="aspect-[5/4] w-full object-cover" />
      <div className="p-6">
        <p className="text-xs font-semibold uppercase tracking-wider text-[#C2410C]">Feito pela beuni</p>
        <h2 className="mt-2 text-2xl font-bold leading-tight text-[#3F2021]">Presentes que fazem a sua marca ser lembrada.</h2>
        <ul className="mt-4 space-y-2.5">
          {VANTAGENS.map((v) => (
            <li key={v} className="flex gap-2.5 text-[15px] leading-snug text-[#5b4546]">
              <span className="mt-0.5 flex size-5 shrink-0 items-center justify-center rounded-full bg-[#FFF1E6] text-[#DC4405]">
                <Check size={12} strokeWidth={3} />
              </span>
              {v}
            </li>
          ))}
        </ul>
        <a
          href={linkCadastro("vitrine")}
          target="_blank"
          rel="noreferrer"
          className="mt-6 flex w-full items-center justify-center gap-2 rounded-xl bg-[#DC4405] px-5 py-3.5 text-[15px] font-bold text-white shadow-[0_6px_16px_rgba(220,68,5,0.25)] transition hover:-translate-y-px hover:bg-[#C2410C]"
        >
          Quero conhecer a beuni
          <ArrowRight size={18} />
        </a>
        <p className="mt-3 text-center text-xs text-[#8a7778]">Crie a conta da sua empresa sem custo</p>
      </div>
    </section>
  );
}

// Faixa baixa, com as fotos numa fileira só (a grade 2×2 ficava grande
// demais no rastreio; Murilo, 20/10/2026).
export function FaixaBeuni() {
  return (
    <section className="bg-[#3F2021] text-white">
      <div className="mx-auto grid max-w-7xl items-center gap-10 px-4 py-12 sm:px-6 lg:grid-cols-[1fr_1.2fr] lg:gap-12 lg:py-14">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wider text-[#FFB990]">Para empresas</p>
          <h2 className="mt-3 text-2xl font-bold leading-tight sm:text-3xl">
            Sua empresa também pode enviar presentes assim.
          </h2>
          <p className="mt-4 max-w-lg text-base leading-relaxed text-[#EADFD3] sm:text-lg">
            A beuni cuida de tudo: cria os kits com a sua marca, guarda no estoque, monta, envia e acompanha cada entrega até as mãos de
            quem recebe.
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href={linkCadastro("faixa_beuni")}
              target="_blank"
              rel="noreferrer"
              className="inline-flex shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-xl bg-[#FF5600] px-6 py-3.5 text-base font-bold text-white transition hover:-translate-y-px hover:bg-[#DC4405]"
            >
              Quero conhecer a beuni
              <ArrowRight size={18} />
            </a>
            <span className="text-sm text-[#CDBDB0]">Crie a conta da sua empresa sem custo.</span>
          </div>
        </div>
        <div className="grid grid-cols-4 gap-3">
          {PRODUTOS.map((p) => (
            <img key={p.alt} src={p.src} alt={p.alt} className="aspect-square w-full rounded-xl object-cover sm:rounded-2xl" />
          ))}
        </div>
      </div>
    </section>
  );
}
